module.exports = __webpack_public_path__ + "static/media/nike-website.7580d611.mp4";